import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { canActivateAuthRole } from './auth/auth-guard';
import { Role } from 'shared-lib';
import { ParkingSpaceComponent } from './parking-space/parking-space.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { SpaceTenantsComponent } from './space-tenants/space-tenants.component';
import { RatesComponent } from './rates/rates.component';
import { TariffManagementComponent } from './tariff-management/tariff-management.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { SettingsComponent } from './settings/settings.component';
import { CreateParkingSpaceComponent } from './parking-space/create-parking-space/create-parking-space.component';
import { CreateParkingZoneComponent } from './parking-space/create-parking-zone/create-parking-zone.component';
import { EditParkingZoneComponent } from './parking-space/edit-parking-zone/edit-parking-zone.component';
import { EditParkingspaceComponent } from './parking-space/edit-parkingspace/edit-parkingspace.component';
import { DeleteParkingZoneComponent } from './parking-space/delete-parking-zone/delete-parking-zone.component';
import { UnassignParkingZoneComponent } from './parking-space/unassign-parking-zone/unassign-parking-zone.component';
import { ParkingSpaceDetailsComponent } from './parking-space/parking-space-details/parking-space-details.component';
import { ParkingSpaceProcessDetailsComponent } from './parking-space/parking-space-process-details/parking-space-process-details.component';
import { ParkingZoneDetailsComponent } from './parking-space/parking-zone-details/parking-zone-details.component';
import { DeviceGroupItemZoneConfigComponent } from './parking-space/parking-zone-details/device-group-item-zone-config/device-group-item-zone-config.component';
import { CameraDetectionListComponent } from './parking-space/parking-zone-details/device-group-item-zone-config/zone-camera/camera-detection-list/camera-detection-list.component';
import { CameraEventsPageComponent } from './parking-space/parking-zone-details/device-group-item-zone-config/zone-camera/camera-events-page/camera-events-page.component';
import { OperatorsUiComponent } from './user-management/operators-ui/operators-ui.component';
import { OperatorsCreateComponent } from './user-management/operators-ui/operators-create/operators-create.component';
import { OperatorEditComponent } from './user-management/operators-ui/operator-edit/operator-edit.component';
import { GroupsUiComponent } from './user-management/groups-ui/groups-ui.component';
import { CustomerListComponent } from './customer-management/customer-list/customer-list.component';
import { CreateCustomerComponent } from './customer-management/create-customer/create-customer.component';
import { CustomerViewComponent } from './customer-management/customer-view/customer-view.component';
import { OperatorGroupMembersComponent } from './customer-management/operator-group-members/operator-group-members.component';
import { ParkingRightComponent } from './parking-right/parking-right.component';
import { TestingPushComponent } from './testing-push/testing-push.component';
import { MasterControllerFormComponent } from './parking-space/parking-space-details/master-controller-list/master-controller-form/master-controller-form.component';
import { CameraExportComponent } from './camera-export/camera-export.component';
import { OrgManagmentComponent } from './org-managment/org-managment.component';
import { OrgCreateComponent } from './org-managment/org-create/org-create.component';
import { OrgViewComponent } from './org-managment/org-view/org-view.component';
import { OrgEditComponent } from './org-managment/org-edit/org-edit.component';
import { PoolConfigAddComponent } from './org-managment/pool-config-add/pool-config-add.component';
import { PoolConfigEditComponent } from './org-managment/pool-config-edit/pool-config-edit.component';
import { PoolConfigTransactionsComponent } from './org-managment/pool-config-transactions/pool-config-transactions.component';
import { MigrationValidationComponent } from './migration-validation/migration-validation.component';
import { LicensePlateOwnershipComponent } from './license-plate-ownership/license-plate-ownership.component';
import { DisplayManagementComponent } from './display-management/display-management.component';
import { HotlineComponent } from './hotline/hotline.component';
import { PaymentObligationsComponent } from './payment-obligations/payment-obligations.component';

export const routes: Routes = [
  // Uncomment the following to enable language-based routing
  // {
  //   path: ':lang',
  //   children: [
  //     {},
  //   ]
  // },
  {
    path: '', component: HomeComponent
  },
  {
    path: 'parking-spaces',
    component: ParkingSpaceComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OperatorAdmin, Role.OperatorMember] }
  },
  {
    path: 'parking-space',
    component: ParkingSpaceComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OperatorAdmin, Role.OperatorMember] }
  },
  {
    path: 'parking-space/new',
    component: CreateParkingSpaceComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-space/:id/edit',
    component: EditParkingspaceComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'parking-space/:id',
    component: ParkingSpaceDetailsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'parking-space/:id/processes',
    component: ParkingSpaceProcessDetailsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'parking-space/:parkingSpaceId/master-controller/new',
    component: MasterControllerFormComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-space/:parkingSpaceId/master-controller/:masterId/edit',
    component: MasterControllerFormComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-zone/new/:parkingSpaceId',
    component: CreateParkingZoneComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-zone/:id',
    component: ParkingZoneDetailsComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'parking-zone/edit/:zoneId',
    component: EditParkingZoneComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-zone/delete/:zoneId',
    component: DeleteParkingZoneComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'camera/:cameraId/detections',
    component: CameraDetectionListComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'camera/:cameraId/events',
    component: CameraEventsPageComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'parking-zone/unassign/:zoneId/:parkingSpaceId',
    component: UnassignParkingZoneComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'parking-zone/:zoneId/device-group/:deviceGroupId',
    component: DeviceGroupItemZoneConfigComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'customer-management',
    component: CustomerListComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'customer-management/create',
    component: CreateCustomerComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'customer-management/:customerId',
    component: CustomerViewComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'customer-management/:customerId/group/:groupId/members',
    component: OperatorGroupMembersComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'org-management',
    component: OrgManagmentComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'org-management/create',
    component: OrgCreateComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    // Ahead of 'org-management/:orgId' deliberately: Angular takes the first match, so a literal
    // segment declared after the parameter one is never reached - 'import' would be read as an
    // organization id and the view would 404 on it.
    //
    // Administrator only. Creating organizations is running the estate rather than administering
    // one of them, which is why an OperatorAdmin does not get it even though they run this page.
    path: 'org-management/import',
    loadComponent: () => import('./org-managment/org-import/org-import.component').then(m => m.OrgImportComponent),
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator] }
  },
  {
    path: 'org-management/:orgId',
    component: OrgViewComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'org-management/:orgId/edit',
    component: OrgEditComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'org-management/:orgId/pool-config/new',
    component: PoolConfigAddComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'org-management/:orgId/pool-config/:configId/transactions',
    component: PoolConfigTransactionsComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'org-management/:orgId/pool-config/:configId',
    component: PoolConfigEditComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  {
    path: 'my-account', component: MyAccountComponent,
  },
  // {
  //   path: 'space-tenants', component: SpaceTenantsComponent,
  //   canActivate: [canActivateAuthRole],
  //   data: { role: Role.OperatorAdmin }
  // },
  // {
  //   path: 'rates', component: RatesComponent,
  //   canActivate: [canActivateAuthRole],
  //   data: { role: Role.OperatorAdmin }
  // },
  // {
  //   path: 'transactions', component: TransactionsComponent,
  //   canActivate: [canActivateAuthRole],
  //   data: { role: Role.OperatorAdmin }
  // },
  {
    path: 'user-management', component: UserManagementComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'user-management/operator-management', component: OperatorsUiComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'user-management/operator-management/create', component: OperatorsCreateComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'user-management/operator-management/edit/:id', component: OperatorEditComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'user-management/groups', component: GroupsUiComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'settings', component: SettingsComponent
  },
  {
    path: 'parking-rights', component: ParkingRightComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'hotline', component: HotlineComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OperatorAdmin, Role.OperatorMember] }
  },
  {
    path: 'hotline/:parkingSpaceId', component: HotlineComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.OperatorAdmin, Role.OperatorMember] }
  },

  // Display Management routes
  {
    path: 'displays',
    component: DisplayManagementComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },

  ///testing-push
  {
    path: 'testing-push', component: TestingPushComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.OperatorAdmin }
  },
  {
    path: 'camera-export',
    component: CameraExportComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.CameraDataExport, Role.OperatorAdmin] }
  },
  {
    path: 'migration-validation',
    component: MigrationValidationComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    path: 'license-plates',
    component: LicensePlateOwnershipComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin, Role.OperatorMember] }
  },
  {
    path: 'license-plate-ownership',
    redirectTo: 'license-plates',
    pathMatch: 'full'
  },
  {
    path: 'tariff-management',
    component: TariffManagementComponent,
    canActivate: [canActivateAuthRole],
    data: { role: Role.Administrator }
  },
  {
    // Open to OperatorAdmin: the backend scopes every payment/obligation query to the caller's own
    // spaces. The guard must match the menu (menu.component.ts).
    path: 'payment-obligations',
    component: PaymentObligationsComponent,
    canActivate: [canActivateAuthRole],
    data: { roles: [Role.Administrator, Role.OperatorAdmin] }
  },
  { path: '**', redirectTo: '' }
];
